import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createValidezNacionalSchema = yup.object({
  fecha_aprobacion: yup.date().required(DEFAULT_MESSAGES.REQUIRED),

  fecha_caducidad: yup.date().required(DEFAULT_MESSAGES.REQUIRED),

  plan_estudio_id: yup.number(),

  normativa_id: yup.number(),

  estado_id: yup.number(),

  expediente_interno: yup.string().required(DEFAULT_MESSAGES.REQUIRED),

  expediente_nacional: yup.string(),
});
